module.exports = __webpack_public_path__ + "static/CarrieMaxwell_Headshot-fc6c86b4aeac9b887a01f506ec6734e1.png";